import { useEffect, useState } from "react";
import { getPostal } from "../../../common-deprecated/utils/postalUtils";
import {
    POSTAL_CHANNEL_T1_COMPARE_V2,
    POSTAL_TOPIC_T1_COMPARE_V2_ADD_CAR,
    POSTAL_TOPIC_T1_COMPARE_V2_OPEN_ONE_CAR,
} from "../../../common-deprecated/constants";
import type { PostalNewDataType } from "../utils/compareTypes";
import { CompareV2Mode } from "../../../shared-logic/features/compare/utils/types";
import Debug from "../../../common-deprecated/Debug";
import { type CompareV2DispatchType, useCompareV2Selector } from "../redux/store";
import { compareClearAll } from "../../../common-deprecated/features/compare/redux/actions/NewCarCompareExternalDataActions";
import { useDispatch } from "../../../shared-logic/redux/store";

// Used to directly open the compare with a car in it. Auto clears the compare when it is closed.
const useInitNewCompareSingleDirectOpen = (
    setExpanded: (state: boolean) => void,
    expanded: boolean,
    animationEnded: boolean,
): void => {
    const cars = useCompareV2Selector((state) => state.newCarCompare.grades);
    const dispatch = useDispatch<CompareV2DispatchType>();
    const [postalIsOpen, setPostalIsOpen] = useState(false);
    useEffect(() => {
        // TODO: this check seems broken, needs to be checked before updating test
        if (!expanded && animationEnded && postalIsOpen && cars.length <= 1) {
            dispatch(compareClearAll());
            setPostalIsOpen(false);
        }
    }, [animationEnded, postalIsOpen]);

    useEffect(() => {
        const postal = getPostal();
        postal.subscribe({
            channel: POSTAL_CHANNEL_T1_COMPARE_V2,
            topic: POSTAL_TOPIC_T1_COMPARE_V2_OPEN_ONE_CAR,
            callback: (data: PostalNewDataType) => {
                if (
                    (data.mode === CompareV2Mode.New || !data.mode) &&
                    data.gradeId &&
                    data.modelId &&
                    data.bodyTypeId
                ) {
                    postal.publish({
                        channel: POSTAL_CHANNEL_T1_COMPARE_V2,
                        topic: POSTAL_TOPIC_T1_COMPARE_V2_ADD_CAR,
                        data: {
                            modelId: data.modelId,
                            bodyTypeId: data.bodyTypeId,
                            submodelId: data.submodelId,
                            gradeId: data.gradeId,
                            colourId: data.colourId,
                        },
                    });
                    setExpanded(true);
                    setPostalIsOpen(true);
                } else {
                    Debug.error(
                        `Could not add car to compare because not all ID's are sent with postal: ${JSON.stringify(
                            data,
                        )}`,
                    );
                }
            },
        });
    }, []);
};

export default useInitNewCompareSingleDirectOpen;
